'use es6';

import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import spinner from 'bender-url!../../img/spinner.png';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class PreviewScreenshot extends Component {
  constructor(...args) {
    super(...args);
    this.renderImage = () => {
      const {
        previewUrl,
        error
      } = this.props;
      if (previewUrl) {
        return /*#__PURE__*/_jsx("img", {
          src: previewUrl,
          className: "screenshot"
        });
      } else if (error) {
        return /*#__PURE__*/_jsxs("div", {
          className: "error",
          children: [/*#__PURE__*/_jsx("div", {
            className: "icon icon-profile-spy"
          }), /*#__PURE__*/_jsx("div", {
            className: "error-text",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "results.preview.error"
            })
          })]
        });
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: "loader",
          children: /*#__PURE__*/_jsx("img", {
            src: spinner
          })
        });
      }
    };
  }
  render() {
    const {
      backgroundUrl,
      isMobile
    } = this.props;
    const rootClasses = "preview" + (isMobile ? " mobile" : "");
    if (isMobile) {
      return /*#__PURE__*/_jsxs("div", {
        className: rootClasses,
        children: [this.renderImage(), /*#__PURE__*/_jsx("img", {
          className: "frame",
          src: backgroundUrl
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: rootClasses,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "bar",
        children: [/*#__PURE__*/_jsx("div", {
          className: "bar-button"
        }), /*#__PURE__*/_jsx("div", {
          className: "bar-button"
        }), /*#__PURE__*/_jsx("div", {
          className: "bar-button"
        })]
      }), this.renderImage()]
    });
  }
}